/** @file Parses input with a zod schema; the first issue becomes a VALIDATION Pose2DError (path + hint). */
import type { z } from 'zod';
import { throwError } from './throwError';

/** Returns the parsed value or throws VALIDATION with `path` = dotted issue path and `hint` = issue message. */
export function parseOrThrow<T>(schema: z.ZodType<T>, input: unknown, pathPrefix = ''): T {
  const parsed = schema.safeParse(input);
  if (parsed.success) return parsed.data;
  const issue = parsed.error.issues[0];
  const extra: { path?: string; hint?: string } = {};
  if (issue) {
    const path = [pathPrefix, ...issue.path.map(String)].filter(Boolean).join('.');
    if (path) extra.path = path;
    extra.hint = issue.message;
  }
  return throwError('VALIDATION', undefined, extra);
}
